import { setCookie } from '../../js/theme/helpers';
const popupData = window.emJsData.country_popup_info;
console.log(popupData);
// Listen for the 'emPopupReady' event that indicates the popup has been inserted
window.addEventListener('emPopupReady', function (event) {
	// Initialize other variables
	const buttons = document.querySelectorAll('.em-country-buttons__button');
	const goButton = document.getElementById('goButton');

	let selectedCountryLink = null;

	// Check if buttons and goButton exist before adding event listeners
	if (buttons.length > 0) {
		// Add click event listeners to each button
		buttons.forEach(button => {
			button.addEventListener('click', function () {
				// Remove 'selected' class from all buttons
				buttons.forEach(btn => btn.classList.remove('em-country-buttons__button--selected'));
				// Add 'selected' class to the clicked button
				button.classList.add('em-country-buttons__button--selected');
				// Store the country link
				selectedCountryLink = button.getAttribute('data-country-link');

				// Get the data-slug value from the clicked button
				const dataSlug = button.getAttribute('data-slug');

				// Check if the slug exists in popupData
				if (popupData && popupData[dataSlug]) {
					// Access the matching data directly
					const matchingItem = popupData[dataSlug];

					// Update text content within the popup
					const headlineElement = document.querySelector('.em-country-buttons__headline');
					const toggleTextElement = document.querySelector('.em-country-buttons__options-text');
					const toggleOnElement = document.querySelector('.toggle__label-on');
					const toggleOffElement = document.querySelector('.toggle__label-off');

					if (headlineElement) {
						headlineElement.textContent = matchingItem.popup_data.headline;
					}
					if (toggleTextElement) {
						toggleTextElement.textContent = matchingItem.popup_data.toggle_text;
					}
					if (toggleOnElement) {
						toggleOnElement.textContent = matchingItem.popup_data.toggle_on_text;
					}
					if (toggleOffElement) {
						toggleOffElement.textContent = matchingItem.popup_data.toggle_off_text;
					}

					// Log the matching item to the console
					console.log('Matching Country Data:', matchingItem);
				} else {
					console.log(`No matching data found for slug: ${dataSlug}`);
				}
			});
		});
	}

	// Check if goButton exists before adding event listener
	if (goButton) {
		// Add click event to "Go" button to redirect
		goButton.addEventListener('click', function () {
			if (selectedCountryLink) {
				// Toggle to hide/show popup again.
				const checkbox = document.querySelector('.em-country-buttons__options .toggle');
				// Get the checked state of the checkbox.
				const isChecked = checkbox.checked;

				// Get Cookie info from local storage.
				const cookieName = localStorage.getItem('cookieName');
				let cookieDuration = localStorage.getItem('cookieDuration');
				if ( isChecked ) {
					// Make sure the duration is set to a year if it is 0.
					if ( cookieDuration === '0' ) {
						cookieDuration = 365;
					}
				} else {
					// If not checked, set cookie to 1 day.
					cookieDuration = 1;
				}
				// Set the cookie to hide the popup.
				setCookie(cookieName, 'true', cookieDuration);
				window.location.href = selectedCountryLink;
			} else {
				alert('Please select a country.');
			}
		});
	}
});
